import { initializePageTransitionLoader } from "./modules/page-transition-loader.js";
import { installLegacySwal } from "./modules/legacy-swal.js";

await (window.__squraFrontendShellReady ?? Promise.resolve());

installLegacySwal();
initializePageTransitionLoader();

document.dispatchEvent(new CustomEvent("squra:frontend-ready"));
